import moment from 'moment'
import 'moment-timezone'
import { useEffect, useState } from 'react'
import { StateCase } from '../../config/enums'
import useStorage from '../../hooks/useStorage'
import { getCompanySelected } from '../../utilities/controlStorage'
import { controlList, storagePage, filterForm } from './storage'

export default function useInitial() {
    const [state, setState] = useState(StateCase.LOADING)
    const { currencies } = useStorage()

    useEffect(() => {
        load().then(pageState => setState(pageState))

        return () => {
            filterForm.init()
        }
    }, [])

    async function load() {
        controlList.filter.changeParams('sort', null)

        const company = getCompanySelected()

        storagePage.timezone = company.timezone

        controlList.filter.setOption('company_id', {
            value: company.id.toString(),
            label: company.name,
            image: company.country.image_url
        })

        const startDate = moment('2020-01-01 12:00')
        controlList.filter.setOption('start_date', {
            value: startDate.format('YYYY-MM-DD'),
            label: startDate.format('DD/MM/YYYY')
        })

        const endDate = moment()
        controlList.filter.setOption('end_date', {
            value: endDate.format('YYYY-MM-DD'),
            label: endDate.format('DD/MM/YYYY')
        })

        filterForm.setParams('stowage_id', {})

        storagePage.currency =
            company.local_currency || currencies.find(c => c.id === 1)

        return StateCase.SUCCESS
    }

    return { state }
}
